import wxUtils from "@/utils/wx";
import * as ww from "@wecom/jssdk";

export const useWxLogin = () => {
    let wwLogin: ww.WWLoginInstance | null = null;

    // 需要配合后端生成签名才可以调用对应的api
    async function getConfigSignature(_url: string) {
        // 根据 url 生成企业签名
        // 生成方法参考 https://developer.work.weixin.qq.com/document/14924
        return { timestamp: "todo", nonceStr: "todo", signature: "todo" };
    }
    const registerWxContext = () => {
        ww.register({
            // 示例 ww7ca4776b2a70000
            corpId: import.meta.env.VITE_APP_ID, // 必填，当前用户企业所属企业ID
            jsApiList: [], // 必填，需要使用的JSAPI列表
            getConfigSignature // 必填，根据url生成企业签名的回调函数
        });
    };
    /**
     * 创建登录组件
     * 注意：ww.createWWLoginPanel 使用场景：在桌面端系统浏览器中直接初始化Web登录组件，无需调用 ww.register、ww.checkJsApi等接口。
     */
    const createLoginPanel = (): Promise<string> => {
        return new Promise((resolve, reject) => {
            const redirect_uri = wxUtils.getRedirectUri();

            // 初始化登录组件
            wwLogin = ww.createWWLoginPanel({
                el: "#ww_login",
                params: {
                    login_type: ww.WWLoginType.corpApp,
                    appid: import.meta.env.VITE_APP_ID,
                    agentid: import.meta.env.VITE_AGENT_ID,
                    redirect_uri,
                    state: "state",
                    redirect_type: ww.WWLoginRedirectType.callback
                },
                onCheckWeComLogin({ isWeComLogin }) {
                    // 登录组件在初始化成功后，开发者可以通过 onCheckWeComLogin 回调中的isWeComLogin参数，判断企业微信的桌面端登录状态。
                    console.log("获取企业微信桌面端登录状态回调", isWeComLogin);
                },
                onLoginSuccess({ code }) {
                    console.log("企业微信登录成功回调", { code });
                    resolve(code);
                },
                onLoginFail(err) {
                    console.log("企业微信登录错误回调", err);
                    reject(err);
                }
            });
        });
    };

    const unmountLoginPanel = () => {
        wwLogin?.unmount();
    };

    return {
        registerWxContext,
        createLoginPanel,
        wwLogin,
        unmountLoginPanel
    };
};
